import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '~/config';
import { publisherStore } from '../stores/publisher/publisherStore';
import { handleNetworkError, withVersionHeaders } from '../utilities/axiosUtilities';
import { badPublisherError, handleException } from '../utilities/errorUtilities';
export function getOrCreatePublisher() {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/publishers`;
  return axios.post(url, undefined, withVersionHeaders()).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getPublisher() {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams?type=publisher`;
  return axios.get(url, withVersionHeaders('2')).then(response => {
    var _response$data;
    const results = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.results;
    if (!Array.isArray(results)) {
      badPublisherError('Pulisher data is not an array.');
      return null;
    }
    if (results.length !== 1) {
      badPublisherError(`Incorrect number of publishers, expected 1 but got '${results.length}'.`);
      return null;
    }
    return results[0].projection;
  }).catch(handleNetworkError);
}
export async function upsertPublisher(publisher) {
  try {
    const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/publisher`;
    const response = await axios.post(url, publisher, withVersionHeaders('2')).then(({
      data
    }) => data);
    if (response !== null && response !== void 0 && response.id) {
      publisherStore.setPublisher({
        ...publisher,
        id: response.id
      });
      return true;
    }
  } catch (error) {
    handleException(error, 'publisherService.upsertPublisher');
  }
  return false;
}
export function getPartnerAggreement() {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/approvals/terms`;
  return axios.get(url).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function postPartnerAggreementAccepted() {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/approvals/terms`;
  return axios.post(url).then(({
    data
  }) => data).catch(handleNetworkError);
}